// Animated <title>: keeps resolving to "Neo" but glitches into scrambled
// garbage between resolves, hacker-terminal style, looping forever.

const TARGET = 'Neo';
// Occasional flavor variants it decodes into (mostly plain "Neo").
const VARIANTS = ['Neo', 'Neo', 'Neo#', 'Ne0', 'NEO', 'Neo_'];
const GARBAGE = '!<>-_\\/[]{}—=+*^?#________ﾊﾐﾋｰｳｼﾅﾟ01';

const rnd = (n) => Math.floor(Math.random() * n);
const junk = () => GARBAGE[rnd(GARBAGE.length)];

let timer = null;

/**
 * Starts the looping title animation. Returns a stop() function.
 * Phases per cycle: hold the word → scramble each letter to garbage and back
 * → settle on the next variant → hold → repeat.
 */
export function startTitleGlitch() {
  if (typeof document === 'undefined') return () => {};
  stopTitleGlitch();

  let variantIndex = 0;

  const setTitle = (s) => {
    document.title = s;
  };

  // Scramble `word` in place: each char independently flickers through
  // garbage for a random number of frames, then locks to its final letter.
  function scrambleTo(word, done) {
    const lock = word.split('').map(() => 6 + rnd(14)); // frames until each char locks
    let frame = 0;
    const step = () => {
      let out = '';
      let settled = 0;
      for (let i = 0; i < word.length; i += 1) {
        if (frame >= lock[i]) {
          out += word[i];
          settled += 1;
        } else {
          out += junk();
        }
      }
      setTitle(out || TARGET);
      frame += 1;
      if (settled === word.length) {
        timer = setTimeout(done, 1500); // hold the resolved word
      } else {
        timer = setTimeout(step, 55);
      }
    };
    step();
  }

  const loop = () => {
    const word = VARIANTS[variantIndex % VARIANTS.length];
    variantIndex += 1;
    scrambleTo(word, loop);
  };

  loop();
  return stopTitleGlitch;
}

export function stopTitleGlitch() {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
}
